// Shared by browser startup and the production build. Never infer a deployment URL.
const FIELDS = ["REACT_APP_SITE_URL", "REACT_APP_BACKEND_URL"];

function validatePublicConfig(environment) {
  const errors = [];
  const origins = {};
  for (const name of FIELDS) {
    const raw = environment[name];
    if (typeof raw !== "string" || !raw.trim()) {
      errors.push({ name, message: `${name} is missing from the frontend build.` });
      continue;
    }
    try {
      const url = new URL(raw.trim());
      if (!["https:", "http:"].includes(url.protocol) || !url.hostname || url.username || url.password || url.search || url.hash || url.pathname !== "/") {
        throw new Error("Invalid public origin");
      }
      origins[name] = url.origin;
    } catch {
      errors.push({ name, message: `${name} must be an absolute HTTP(S) origin without a path, credentials, query, or fragment.` });
    }
  }
  return { valid: errors.length === 0, errors, siteUrl: origins.REACT_APP_SITE_URL, backendUrl: origins.REACT_APP_BACKEND_URL };
}

function assertPublicConfig(environment) {
  const result = validatePublicConfig(environment);
  if (!result.valid) {
    throw new Error(`Frontend build configuration is incomplete:\n${result.errors.map(error => `- ${error.message}`).join("\n")}\nSet these public URLs in frontend/.env (or the build environment), then rebuild. Existing files must not be replaced with a misconfigured bundle.`);
  }
  return result;
}

module.exports = { validatePublicConfig, assertPublicConfig };